export default `
    --gradient-gimmick-bar-height: 4px;
`;
